import * as d3 from 'd3'

export default {
  methods: {

    draw_barChart() {

      // Draw Bar Chart 
      this.timeline.xItems.forEach((d,i)=> {

        let stackY = this.chart.height

        this.chart.columns.forEach((st,s)=> {
          
          let value = this.chartData.find(f=> f[this.timeline.refCode] == d.name)[st.code]
          if(value == undefined || value < 0) value = 0

          stackY = stackY - this.primary.axis(value)

          this.canvasChart
          .append('rect')
          .attr('x', d.mx - (this.chart.barSize/2))
          .attr('y', stackY)
          .attr('width', this.chart.barSize).attr('height', this.primary.axis(value))
          .attr('fill', st.bColor).attr('opacity', st.opacity)
          
          if(st.vSize > 0 && value > 0) {
            this.canvasChart
            .append('text')
            .attr('class', `VALUE_${this.localId}`)
            .attr('x', d.mx)
            .attr('y', stackY + (this.primary.axis(value)/2) + st.vSize*0.36)
            .attr('font-size', st.vSize).attr('fill',  st.vColor)
            .attr('text-anchor', 'middle')
            .text(value+(st.unit ? st.unit : ''))
          }

        })

        // Period Total
        let stack = this.chart.stackTotal
        if(stack.visible == 'Y') {
          this.canvasChart
          .append('text')
          .attr('x', d.mx)
          .attr('y', stackY - 4)
          .attr('font-size', stack.tSize).attr('fill',  stack.tColor)
          .attr('text-anchor', 'middle')
          .text(d.sum)
        }

      })

      d3.selectAll(`.VALUE_${this.localId}`).moveToFront()

    },
    
  }
}